import { render } from "./main.vue?vue&type=template&id=31f5ffdc"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"

import "./main.vue?vue&type=style&index=0&id=31f5ffdc&lang=css"

import exportComponent from "/home/collin/workspace/elands/elandsweb/main-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__